module.exports = __webpack_public_path__ + "img/jiaoyu_xibeinonglin_suoluetu.49e7469b.png";